import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'Redux/User/slice';
import { IDataMessage } from 'Shared/Types/chat';
import { FileOutlined, DownloadOutlined } from '@ant-design/icons';
import { bytesToMegabytes } from 'Shared/Utils';
import styles from './DataMessage.module.scss';

type DataMessageProps = {
  message: IDataMessage;
};

export const DataMessage: React.FC<DataMessageProps> = ({ message }) => {
  const currentUser = useSelector(selectCurrentUser);
  const isOutgoing =
    message.user_name ===
    `${currentUser?.first_name} ${currentUser?.last_name}`;
  const fileName = message.link.split('/').pop();

  const handleDownloadClick = () => {
    const anchor = document.createElement('a');
    anchor.href = message.link;
    anchor.download = fileName || '';
    anchor.click();
  };

  return (
    <div className={styles.dataMessage}>
      <FileOutlined
        className={`${styles.dataMessage__icon} ${
          isOutgoing && styles.dataMessage_outgoing__icon
        }`}
      />

      <div className={styles.dataMessage__main}>
        <span className={styles.dataMessage__main__fileName}>
          {fileName}
        </span>
        <span
          className={`${styles.dataMessage__main__fileSize} ${
            isOutgoing && styles.dataMessage_outgoing__main__fileSize
          }`}
        >
          {bytesToMegabytes(message.file_size)}
        </span>
      </div>

      <button
        className={`${styles.dataMessage__downloadButton} ${
          isOutgoing && styles.dataMessage_outgoing__downloadButton
        }`}
        onClick={handleDownloadClick}
      >
        <DownloadOutlined />
      </button>
    </div>
  );
};
